import { z } from 'zod';
import { buildFieldSchemas } from './build-field-schema/build-field-schema';
import { buildFormSchemas } from './build-form-schema/build-form-schema';
import { FormField, FormRule } from '../dynamic-form.types';

export function buildZodSchema(
  items: FormField[],
  rules: FormRule[],
  extend?: (
    schema: z.ZodObject<Record<string, z.ZodTypeAny>>
  ) => z.ZodObject<Record<string, z.ZodTypeAny>>
) {
  const fieldSchemas = buildFieldSchemas(items);
  const dynamicPropertiesSchema = z.object(fieldSchemas);

  let baseSchema: z.ZodObject<Record<string, z.ZodTypeAny>> = z.object(
    dynamicPropertiesSchema.shape
  );

  if (extend) {
    baseSchema = extend(baseSchema);
  }

  return buildFormSchemas(baseSchema, rules);
}
